import moment from 'jalali-moment';
import {ReactElement, useCallback, useEffect, useState} from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Select from 'react-select';
import Swal from 'sweetalert2';
import endpoints from '../../config/endpoints';
import globalEnum from '../../enums/globalEnum';
import homeReducer, { setLoading } from '../../services/reducers/homeSlice';
import restApi from '../../services/restApi';
import tools from '../../utils/tools';
import { Sidebar } from '../Layout/Sidebar';
import { NumberFormatBase, PatternFormat } from 'react-number-format';
import { middle } from '../../services/reducers/popupSlice';
import CommerceDetailsModal from './CommerceDetailsModal';
import orderStatus2 = globalEnum.orderStatus2;
import orderStatus = globalEnum.orderStatus;
import {useAppSelector} from "../../services/store";
import userRole = globalEnum.userRole;
import userReducer from "../../services/reducers/userSlice";

const DEFAULT_PRODUCT = {
  sku: 'انتخاب کنید',
  title: 'انتخاب کنید',
  boxCount: 1,
  rollCount: 1,
  itemsPerRoll: 1,
  itemsPerBox: 1,
};
const DEFAULT_ORDER_PRODUCT = {
  productId: null,
  count: 1,
  singlePrice: 1,
  discountPrice:1,
  itemsPerUnitType: 1,
  product: DEFAULT_PRODUCT
}

const OrderManage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const userReducer = useAppSelector(state => state.userReducer)
  const [form, setForm] = useState<any>({ isMulti: false, orderProducts: [], transportation: 0, finalPrice: 0, discountAmount: 0, productId: null});
  const [initialStatus, setInitialStatus] = useState(orderStatus.UnapprovedCommerceBearing)
  const [products, setProducts] = useState([]);
  const [orderAction, setOrderAction] = useState<string>('');
  const navigate = useNavigate();

  const send = async () => {
    dispatch(setLoading(true));

    // Determine the final status based on user role and action
    let finalStatus = form.status;
    if (userReducer.profile.role === "FELTBOWLCOMMERCE") {
      if (orderAction === 'reject') {
        finalStatus = orderStatus.UnapprovedCommerceFeltBowl;
      } else if (orderAction === 'approve') {
        finalStatus = orderStatus.WaitForWarehouseApproval;
      }
    }

    let addressRes, userRes, verifyNationalCode;

    if (!id){
      userRes = await restApi(process.env.REACT_APP_BASE_URL + '/admin/user/basic/' + (form?.user?.id || '') ).post({
        name: form.user.name,
        lastName: form.user.lastName,
        nationalCode: form.user.nationalCode,
        phoneNumber: form.user.phoneNumber,
        isVerified: verifyNationalCode?.code == 200 || form.user.isVerified
      })

      if (form.address) {
        addressRes = await restApi(process.env.REACT_APP_BASE_URL + '/admin/address/basic/' + (form?.address?.id || '')).post({
          title: form.address.title,
          phoneNumber: form.address.phoneNumber,
          description: form.address.description,
          vahed: form.address.vahed,
          pelak: form.address.pelak,
          userId: userRes.data?.id
        });
      }
    }

    const res = await restApi(process.env.REACT_APP_BASE_URL + '/admin/order/basic/' + (id || ''), true).post({
      date: form.date,
      time: form.time,
      finalPrice: form.finalPrice,
      price: form.price,
      productId: form.productId,
      discountAmount: form.discountAmount,
      transportation: form.transportation,
      addressId: form.address?.id || addressRes?.data?.id,
      userId: form.user?.id || userRes.data?.id,
      isMulti: form.isMulti,
      isUrgent: form.isUrgent,
    })

    if (res.code === 200) {
      const productRes = await restApi(process.env.REACT_APP_BASE_URL + '/admin/order/products/' + res.data.id).put({
        products: form.orderProducts.filter(e => e.productId != null).map(e => ({
          productId: e.productId,
          count: e.count,
          unitType: e.unitType
        })),
        newStatus: finalStatus,
        oldStatus: initialStatus
      });

      if (productRes.code === 1313) {
        Swal.fire({
          title: 'ناموفق',
          text: "تعداد کالای انتخاب شده بیشتر از موجودی است",
          icon: 'error',
          confirmButtonText: 'متوجه شدم'
        });
        dispatch(setLoading(false));
        return;
      }

      // Check if order was split
      if (productRes.data?.bearingOrder && productRes.data?.feltbowlOrder) {
        Swal.fire({
          title: 'سفارش تقسیم شد',
          html: `
          <p>سفارش به دو سفارش جداگانه تقسیم شد:</p>
          <br/>
          <p><strong>سفارش بلبرینگ:</strong> ${productRes.data.bearingOrder.code}</p>
          <p>وضعیت: ${productRes.data.bearingOrder.status === orderStatus.UnapprovedCommerceBearing ? 'عدم تایید بازرگان بلبرینگ' : 'در انتظار تایید انبار'}</p>
          <br/>
          <p><strong>سفارش کاسه نمد:</strong> ${productRes.data.feltbowlOrder.code}</p>
          <p>وضعیت: ${productRes.data.feltbowlOrder.status === orderStatus.UnapprovedCommerceFeltBowl ? 'عدم تایید بازرگان کاسه نمد' : 'در انتظار تایید بازرگان کاسه نمد'}</p>
        `,
          icon: 'info',
          confirmButtonText: 'متوجه شدم',
          didClose() {
            navigate('/order');
          }
        });
        dispatch(setLoading(false));
        return;
      }

      // If not split, update status normally
      const statusRes = await restApi(process.env.REACT_APP_BASE_URL + '/admin/order/status/' + res.data.id).put({
        status: finalStatus,
      })

      Swal.fire({
        title: 'موفق',
        text: 'سفارش با موفقیت ویرایش شد',
        icon: 'success',
        confirmButtonText: 'متوجه شدم',
        didClose() {
          navigate(-1);
        }
      });
    } else {
      Swal.fire({
        title: 'ناموفق',
        text: res?.data || 'خطایی رخ داده است',
        icon: 'error',
        confirmButtonText: 'متوجه شدم'
      });
    }

    dispatch(setLoading(false));
  };

  const calculateRoleSpecificPrice = () => {
    if (!form?.orderProducts || form.orderProducts.length === 0 || products.length === 0) {
      return { price: 0, finalPrice: 0, discountAmount: 0 };
    }

    let totalPrice = 0;
    let totalDiscount = 0;

    for (const orderProduct of form.orderProducts) {
      const productObj = products.find(p => p.id === orderProduct.productId);
      if (!productObj) continue;

      const category = orderProduct?.product?.category;

      // For bearing commerce, only count non-feltbowl products
      if (userReducer?.profile?.role === userRole.bearingCommerce) {
        if (category?.slug !== 'کاسه-نمد') {
          const itemPrice = orderProduct.count * orderProduct.itemsPerUnitType * orderProduct.singlePrice;
          totalPrice += itemPrice;
          if (orderProduct.discountPrice) {
            totalDiscount += orderProduct.count * orderProduct.itemsPerUnitType * orderProduct.discountPrice;
          }
        }
      }
      // For feltbowl commerce, only count feltbowl products
      else if (userReducer?.profile?.role === userRole.feltBowlCommerce) {
        if (category?.slug === 'کاسه-نمد') {
          const itemPrice = orderProduct.count * orderProduct.itemsPerUnitType * orderProduct.singlePrice;
          totalPrice += itemPrice;
          if (orderProduct.discountPrice) {
            totalDiscount += orderProduct.count * orderProduct.itemsPerUnitType * orderProduct.discountPrice;
          }
        }
      }
      // For other roles, show full price
      else {
        const itemPrice = orderProduct.count * orderProduct.itemsPerUnitType * orderProduct.singlePrice;
        totalPrice += itemPrice;
        if (orderProduct.discountPrice) {
          totalDiscount += orderProduct.count * orderProduct.itemsPerUnitType * orderProduct.discountPrice;
        }
      }
    }

    return {
      price: totalPrice,
      discountAmount: totalDiscount,
      finalPrice: totalPrice - totalDiscount
    };
  };

  const getVisibleProductsCount = () => {
    if (!form?.orderProducts) return 0;

    let count = 0;
    for (const orderProduct of form.orderProducts) {
      const category = orderProduct?.product?.category;

      if (userReducer?.profile?.role === userRole.bearingCommerce) {
        if (category?.slug !== 'کاسه-نمد') count++;
      } else if (userReducer?.profile?.role === userRole.feltBowlCommerce) {
        if (category?.slug === 'کاسه-نمد') count++;
      } else {
        count++;
      }
    }

    return count;
  };

  const list = () => {
    const rows: ReactElement[] = [];

    // Check if there are no visible products for this role
    const visibleCount = getVisibleProductsCount();

    if (visibleCount === 0 && form?.orderProducts?.length > 0) {
      const message = userReducer?.profile?.role === userRole.bearingCommerce
        ? 'این سفارش فقط شامل محصولات کاسه نمد است. می‌توانید وضعیت را به مرحله بعد تغییر دهید.'
        : 'این سفارش فقط شامل محصولات بلبرینگ است. می‌توانید وضعیت را به مرحله بعد تغییر دهید.';

      rows.push(
        <tr key="empty-message">
          <td colSpan={9} style={{ textAlign: 'center', padding: '40px', fontSize: '16px', color: '#666' }}>
            {message}
          </td>
        </tr>
      );

      return rows;
    }

    form?.orderProducts?.map((orderProduct: any, index) => {
      const key = index
      const userAccess = form.user?.accesses?.find(e => e.entityType == 'Product' && e.entityId == orderProduct.productId);
      const productObj = products.find(e => e.id == orderProduct.productId) || DEFAULT_PRODUCT
      if (userReducer.profile.role == userRole.feltBowlCommerce && orderProduct?.product?.category?.slug !== 'کاسه-نمد'){
        return;
      }
      if (userReducer.profile.role == userRole.bearingCommerce && orderProduct?.product?.category?.slug === 'کاسه-نمد'){
        return;
      }
      rows.push(
        <tr className="" key={'product' + index}>
          <td className="backGround1">
            <p>{tools.formatPrice(productObj?.price * orderProduct.count * (orderProduct.itemsPerUnitType || (userAccess?.unitType == 'box' ? productObj?.itemsPerBox : productObj?.itemsPerRoll)))}</p>
          </td>
          <td>
            <p>{tools.formatPrice(productObj?.price)}</p>
          </td>
          <td className="quantity">
            <div className="quantityButtom">
              <i className="tablePlusIcon" onClick={(e: any) => {
                setForm(prev => {
                  const cp = { ...prev }
                  cp.orderProducts[key].count = Number(cp.orderProducts[key].count) + 1
                  return cp;
                })
              }}></i>
              <input className="quantityNumber" value={orderProduct.count}
                     onChange={(input) => setForm(prev => {
                       const cp = { ...prev }
                       cp.orderProducts[key].count = Number(input.target.value)
                       return cp;
                     })}
              />
              <i className="tableCollapsIcon" onClick={(e: any) => {
                setForm(prev => {
                  const cp = { ...prev }
                  if (cp.orderProducts[key].count > 1) {
                    cp.orderProducts[key].count = Number(cp.orderProducts[key].count) - 1;
                  }
                  return cp;
                })
              }}></i>
            </div>
          </td>
          <td>
            <Select
              className="selectOrderManage"
              options={[{ value: 'box', label: 'قوطی' }, { value: 'roll', label: 'رولی' }]}
              value={(() => {
                const currentUnitType = orderProduct.unitType || userAccess?.unitType || 'box';
                return { value: currentUnitType, label: currentUnitType === 'box' ? 'قوطی' : 'رولی' };
              })()}
              onChange={(selected) => setForm(prev => {
                const cp = { ...prev };
                const newItemsPerUnitType = selected.value === 'box' ? productObj?.itemsPerBox : productObj?.itemsPerRoll;
                cp.orderProducts[key].unitType = selected.value;
                cp.orderProducts[key].itemsPerUnitType = newItemsPerUnitType || 1;
                return cp;
              })}
            />
          </td>
          <td>
            <span
              className="clickable"
              style={{ textDecoration: 'underline' }}
              onClick={() => dispatch(middle(<CommerceDetailsModal product={productObj} />))}
            >
              {tools.formatPrice(productObj?.commerceCount || 0)}
            </span>
          </td>
          <td>{productObj?.boxCount || 0} × {productObj?.itemsPerBox || '—'}</td>
          <td>{productObj?.rollCount || 0} × {productObj?.itemsPerRoll || '—'}</td>
          <td className="">
            <Select
              className="selectOrderManage"
              options={products.filter(e => e.price > 0).map(e => ({ value: e.id, label: e?.title + ' - ' + e.sku}))}
              value={{value: orderProduct.productId, label:  productObj?.sku }}
              onChange={(selected) => {setForm(prev => {
                const cp = {...prev}
                const selectedProduct = products.find(p => p.id === selected.value);
                const newUserAccess = form.user?.accesses?.find(e => e.entityType == 'Product' && e.entityId == selected.value);
                const newUnitType = newUserAccess?.unitType || 'box';
                const itemsPerUnitType = (newUnitType == 'box' ? selectedProduct?.itemsPerBox : selectedProduct?.itemsPerRoll) || 1;

                // Check if this product already exists in another row
                const existingIndex = prev.orderProducts.findIndex((e, i) => e.productId === selected.value && i !== key);

                if (existingIndex !== -1) {
                  // Merge: add current row's count to existing row and remove current row
                  cp.orderProducts = prev.orderProducts.map((item, i) => {
                    if (i === existingIndex) {
                      return { ...item, count: item.count + (prev.orderProducts[key]?.count || 1) };
                    }
                    return item;
                  }).filter((_, i) => i !== key);
                } else if(key == undefined || key < 0){
                  cp.orderProducts = [...prev.orderProducts, {
                    productId: selected.value,
                    count: 1,
                    singlePrice: selectedProduct?.price || 0,
                    discountPrice: selectedProduct?.discountPrice || 0,
                    unitType: newUnitType,
                    itemsPerUnitType: itemsPerUnitType,
                    product: selectedProduct
                  }];
                } else {
                  cp.orderProducts[key] = {
                    ...cp.orderProducts[key],
                    productId: selected.value,
                    singlePrice: selectedProduct?.price || 0,
                    discountPrice: selectedProduct?.discountPrice || 0,
                    unitType: newUnitType,
                    itemsPerUnitType: itemsPerUnitType,
                    product: selectedProduct
                  }
                }
                return cp;
              })}}
            />
          </td>
          <td>{++index}</td>
          <td className="minWidth50">
            <i className="cancelSvg" onClick={() => setForm(prev => ({ ...prev, orderProducts: prev.orderProducts.filter(e => e.productId != orderProduct.productId)}))}></i>
          </td>
        </tr>
      )
    })

    return rows;
  };

  const fetchData = async () => {
    dispatch(setLoading(true));

    if (id) {
      const res = await restApi(endpoints.order.single + id, true).get();

      setForm({
        status: res.data?.status,
        finalPrice: Number(res.data?.finalPrice),
        price: res.data?.price,
        discountAmount: res.data?.discountAmount,
        orderProducts: res.data?.orderProducts,
        address: res.data?.address,
        createdAt: res.data?.createdAt,
        user: res.data?.user,
      });

      setInitialStatus(res.data?.status)
      await fetchUser(res.data?.user?.phoneNumber)
    }

    const res = await Promise.all([
      restApi(endpoints.product.awaitCommerce, true).get()
    ])

    setProducts(res[0].data);
    dispatch(setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchUser = async (phoneNumber = form?.user?.phoneNumber) => {
    const res = await restApi(endpoints.user.findBy, true).get({phoneNumber: phoneNumber});
    if (res.code == 200) {
      setForm(prev => ({...prev, user: res.data}))
    }
  }

  useEffect(() => {
    if(form?.orderProducts.length > 0 && products.length > 0) {
      const { price, finalPrice, discountAmount } = calculateRoleSpecificPrice();
      setForm(prev => ({
        ...prev,
        price: price,
        finalPrice: finalPrice,
        discountPrice: discountAmount
      }));
    }
  }, [JSON.stringify(form?.orderProducts), form?.discountAmount, products, userReducer?.profile?.role]);

  const handleOrderActionChange = (value: string) => {
    setOrderAction(value);
  };

  return(
    <>
      <body className="dashboardBody">
      <Sidebar/>
      <main className="dashBoardMain main">
        <div className="addInfoHeader">
          <button className="dashboardHeader keepRight" onClick={send}>
            <p>ثبت سفارش</p>
          </button>
          <span>
            <h1 className="sideBarTitle"> بازگشت به صفحه لیست سفارش ها</h1>
             <h1 className="dashBoardTitle">ویرایش سفارش</h1>
          </span>
          <i className="backAdd" onClick={() => navigate('/order')}></i>
        </div>
        <section className="topRow">
          <div className="infoSection">
            <h1 className="dashBoardTitle">اطلاعات کاربر</h1>
            <div className="userInfoContainer">
              <label className="sideBarTitle">شماره تلفن</label>
              <input className="editProductInput" value={form?.user?.phoneNumber || ''} onChange={async (input) => {
                setForm(prev => ({ ...prev, user: {
                    ...prev.user, phoneNumber: input.target.value
                  }}))
                if (input.target.value.length == 11) {
                  await fetchUser(input.target.value);
                }
              }}/>
              <label className="sideBarTitle">نام</label>
              <input className="editProductInput" value={form?.user?.name || ''} onChange={(input) => {
                setForm(prev => ({
                  ...prev,
                  user: {
                    ...prev.user,
                    name: input.target.value
                  }
                }))
              }}/>
              <label className="sideBarTitle">نام و خانوادگی</label>
              <input className="editProductInput" value={form?.user?.lastName || ''} onChange={(input) => {
                setForm(prev => ({
                  ...prev,
                  user: {
                    ...prev.user,
                    lastName: input.target.value
                  }
                }))
              }}/>
              <label className="sideBarTitle" >کد ملی</label>
              <input className="editProductInput" value={form?.user?.nationalCode || ''} onChange={(input) => {
                setForm(prev => ({
                  ...prev,
                  user: {
                    ...prev.user,
                    nationalCode: input.target.value
                  }
                }))
              }}/>
            </div>
          </div>
          <div className="infoSection">
            <h1 className="dashBoardTitle">اطلاعات سفارش</h1>
            <div className="userInfoContainer">
              {userReducer.profile.role === "FELTBOWLCOMMERCE" ? (
                <>
                  <label className="sideBarTitle">وضعیت سفارش</label>
                  <div className="order-action-radio-group">
                    <div className="radio-option">
                      <input
                        type="radio"
                        id="approve-order"
                        name="orderAction"
                        value="approve"
                        checked={orderAction === 'approve'}
                        onChange={(e) => handleOrderActionChange(e.target.value)}
                      />
                      <label htmlFor="approve-order" className="radio-label">
                        تایید و ارسال به انبار
                      </label>
                    </div>
                    <div className="radio-option">
                      <input
                        type="radio"
                        id="reject-order"
                        name="orderAction"
                        value="reject"
                        checked={orderAction === 'reject'}
                        onChange={(e) => handleOrderActionChange(e.target.value)}
                      />
                      <label htmlFor="reject-order" className="radio-label">
                        عدم تایید سفارش کاسه نمد
                      </label>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <label className="sideBarTitle">وضعیت سفارش</label>
                  <Select
                    name='status'
                    value={{
                      value: Object.keys(orderStatus2).find(e => e == form?.status) || 'WaitForCommerceBearingApproval',
                      label: orderStatus2[Object.keys(orderStatus2).find(e => e == form?.status) || 'WaitForCommerceBearingApproval']
                    }}
                    defaultValue={{
                      value: 'WaitForCommerceBearingApproval',
                      label: orderStatus2['WaitForCommerceBearingApproval']
                    }}
                    options={Object.entries(orderStatus2).map(([key, value]) => ({value: key, label: value}))}
                    className="dashCardLog"
                    id="infoTitle"
                    onChange={(selected) => setForm(prev => ({ ...prev, status: selected.value }))}
                  />
                  <label className="sideBarTitle">تاریخ</label>
                  <input
                    className="editProductInput"
                    value={(form?.date || moment().add(2, 'd').format('jYYYY/jMM/jDD'))}
                    onChange={(input) => setForm(prev => ({ ...prev, date: input.target.value}))}
                  />
                </>
              )}
            </div>
          </div>
        </section>
        <section className="topRow">
          <div className="infoSection">
            <h1 className="dashBoardTitle">آدرس</h1>
            <div className="userInfoContainer">
              <label className="sideBarTitle">آدرس های پیشین</label>
              <Select className="addressInput dirRtl width100" options={tools.selectFormatter(form.user?.addresses, 'id', 'description', 'آدرس جدید')} defaultValue={{
                value: form?.addressId || '',
                label: form.user?.addresses?.find(e => e.id == form?.addressId)?.description
              }} id="infoTitle" onChange={(selected) => setForm(prev => ({
                ...prev,
                address: form.user?.addresses?.find(e => e.id == selected.value) || { phoneNumber: '',title: '', vahed: '', pelak: '', description: '', id: null}
              }))}/>
              <label className="sideBarTitle" htmlFor="addressTitle">عنوان</label>
              <input className="editProductInput" type="text" id="addressTitle" name="addressPhone" value={form.address?.title || ''} onChange={(input: any) => setForm(prev => ({
                ...prev,
                address: {
                  ...prev.address,
                  title: input.target.value
                }
              }))}/>
              <label className="sideBarTitle" htmlFor="addressPhone">شماره تماس</label>
              <input className="editProductInput" type="text" id="addressPhone" name="addressPhone" value={form.address?.phoneNumber || ''} onChange={(input: any) => setForm(prev => ({
                ...prev,
                address: {
                  ...prev.address,
                  phoneNumber: input.target.value
                }
              }))}/>
              <label className="sideBarTitle" htmlFor="postalCode">پلاک</label>
              <input className="editProductInput" type="text" id="postalCode" name="addressPostal" value={form.address?.pelak || ''} onChange={(input: any) => setForm(prev => ({
                ...prev,
                address: {
                  ...prev.address,
                  pelak: input.target.value
                }
              }))}/>
              <label className="sideBarTitle" htmlFor="vahed">واحد</label>
              <input className="editProductInput" type="text" id="vahed" name="addressPostal" value={form.address?.vahed || ''} onChange={(input: any) => setForm(prev => ({
                ...prev,
                address: {
                  ...prev.address,
                  vahed: input.target.value
                }
              }))}/>
              <label className="sideBarTitle" htmlFor="address">جزئیات آدرس</label>
              <textarea className="editProductInput" id="address" name="addressText" value={form.address?.description || ''} onChange={(input: any) => setForm(prev => ({
                ...prev,
                address: {
                  ...prev.address,
                  description: input.target.value
                }
              }))}/>
            </div>
          </div>
          <div className="infoSection">
            <h1 className="dashBoardTitle">مجموع فاکتور</h1>
            <div className="userInfoContainer">
    <span className="factorHeader">
      <p>{moment(form?.createdAt).format('jYYYY/jMM/jDD')}</p>
    </span>
              <span className="billItems dashboardBill">
      <h3 className="billItem">مبلغ سفارش</h3>
      <div className="pricePart">
        <NumberFormatBase
          className="billPrice"
          value={form?.price || ''}
          onValueChange={(values) => {
            const { value } = values;
            setForm(prev => ({
              ...prev,
              price: value ? Number(value.replace(/,/g, '')) : ''
            }));
          }}
          format={(str) => tools.formatPrice(Number(str))}
        />
      </div>
    </span>
              <span className="billItems dashboardBill">
      <h3 className="billItem">تخفیف</h3>
      <div className="pricePart">
        <NumberFormatBase
          className="billPrice"
          value={form?.discountAmount || 0}
          onValueChange={(values) => {
            const { value } = values;
            setForm(prev => ({
              ...prev,
              discountAmount: value ? Number(value.replace(/,/g, '')) : 0
            }));
          }}
          format={(str) => tools.formatPrice(Number(str))}
        />
      </div>
    </span>
              <hr className="dashedBill"/>
              <span className="billItems dashboardBill">
      <h3 className="billItem">مبلغ قابل پرداخت</h3>
      <div className="pricePart">
        <NumberFormatBase
          className="tablePrice1"
          value={form?.finalPrice || 0}
          onValueChange={(values) => {
            const { value } = values;
            setForm(prev => ({
              ...prev,
              finalPrice: value ? Number(value.replace(/,/g, '')) : 0
            }));
          }}
          format={(str) => tools.formatPrice(Number(str))}
        />
      </div>
    </span>
            </div>
          </div>
        </section>
        <section className="bottom width100">
          <h6 className="dashBoardTitle">محصولات</h6>
          <table className="productTable">
            <thead className="editOrderTable">
            <th className="sideBarTitle center" >قیمت کل</th>
            <th className="sideBarTitle center" >قیمت واحد</th>
            <th className="sideBarTitle center" >تعداد</th>
            <th className="sideBarTitle center" >واحد</th>
            <th className="sideBarTitle center" >تعداد در حال فروش (عدد)</th>
            <th className="sideBarTitle center" >تعداد کارتن قوطی</th>
            <th className="sideBarTitle center" >تعداد کارتن رولی</th>
            <th className="sideBarTitle center" >محصول</th>
            <th className="sideBarTitle center" >ردیف</th>
            <th className="sideBarTitle center" ></th>
            </thead>
            <tbody>
            {list()}
            <tr className="addProductTr">
              <td className="addProductButton clickable" onClick={() => {
                const firstProduct = products.find(e => e.price > 0);
                if (firstProduct) {
                  setForm(prev => ({
                    ...prev,
                    orderProducts: [...prev.orderProducts,DEFAULT_ORDER_PRODUCT]
                  }));
                }
              }}>اضافه کردن محصول</td>
            </tr>
            </tbody>
          </table>
        </section>
      </main>
      </body>
    </>
  )
}
export default OrderManage;